var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from "lit";
import { customElement } from "lit/decorators.js";
import "./wh-icon";
import { linkStyles } from "../styles/link.styles";
let WhFooterElement = class WhFooterElement extends LitElement {
    render() {
        return html `<footer>
      <slot name="inside-footer-content"></slot>
      <slot name="outside-footer-content">
        <div class="links-legal">
          <a
            href="https://www.walgreens.com/topic/help/general/noticeprivacypractices.jsp"
            >Notice of Privacy Practices</a
          >
          <a
            href="https://www.walgreens.com/topic/help/generalhelp/termsofuse.jsp"
            >Terms of Use</a
          >
          <a
            href="https://www.walgreens.com/topic/help/generalhelp/privacyandsecurity.jsp"
            >Online Privacy & Security</a
          >
        </div>
        <div class="copyright">
          &copy; Copyright 2022 Walgreen Co. 200 Wilmot Rd., Deerfield, Il. All
          rights reserved.
        </div>
      </slot>
    </footer>`;
    }
};
/* Stryker disable next-line StringLiteral */
WhFooterElement.styles = css `
    /* stylelint-disable-next-line max-line-length */
    /* stylelint-disable-next-line selector-descendant-combinator-no-non-space,selector-type-no-unknown,comment-empty-line-before */
    ${linkStyles}
    footer {
      font-family: "Source Sans Pro", sans-serif;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
    }

    [name="inside-footer-content"]::slotted(*) {
      display: flex;
      align-items: center;
      flex-direction: column;
      gap: 20px;
      background: var(--wh-theme-colors-background, #c2e8ff);
      padding: 40px 0;
    }

    [name="outside-footer-content"] {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      gap: 20px;
    }

    .copyright {
      font-weight: 400;
    }

    .links-legal {
      padding: 1.125em 1.25em;
    }

    .links-legal a {
      margin: 0 10px;
    }

    @media only screen and (width <= 1145px) {
      [name="outside-footer-content"] {
        flex-flow: column wrap;
        align-items: center;
        justify-content: center;
      }
    }

    /*For Mobile Phone*/
    @media only screen and (width <= 620px) {
      .copyright {
        text-align: center;
      }

      .links {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 20px;
      }

      .links-legal {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 20px;
      }
    }
  `;
WhFooterElement = __decorate([
    customElement("wh-footer")
], WhFooterElement);
export { WhFooterElement };
